
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/museumsplan",
      function () {
        return require("private-next-pages/[domain]/museumsplan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/museumsplan"])
      });
    }
  